const ALLOWED_TYPES = new Set(['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']);
const PROFILE_PICTURE_SIZE = 256;
const JPEG_QUALITY = 0.85;

export const isAllowedProfilePictureType = (type: string) => ALLOWED_TYPES.has(type);

export const fileToProfilePictureDataUrl = (file: File): Promise<string> => (
  new Promise((resolve, reject) => {
    if (!isAllowedProfilePictureType(file.type)) {
      reject(new Error('INVALID_TYPE'));
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => reject(new Error('READ_FAILED'));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error('INVALID_IMAGE'));
      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = PROFILE_PICTURE_SIZE;
        canvas.height = PROFILE_PICTURE_SIZE;
        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('READ_FAILED'));
          return;
        }

        const minSide = Math.min(image.width, image.height);
        const sx = (image.width - minSide) / 2;
        const sy = (image.height - minSide) / 2;
        context.drawImage(
          image,
          sx,
          sy,
          minSide,
          minSide,
          0,
          0,
          PROFILE_PICTURE_SIZE,
          PROFILE_PICTURE_SIZE,
        );
        resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
      };
      image.src = reader.result as string;
    };
    reader.readAsDataURL(file);
  })
);
